/*
 * 统一管理从服务端获取的数据，方便后期维护
 * 通过export  暴露封装的获取数据方法
 */
import Axios from "axios";

const sign = process.env.VUE_APP_SERVER_URL2

// 检查
export const checkComparisonApi = (data) => Axios.get(sign + '/check/comparison', data);
//获取所有报名的公司名称
export const checkEntByNameApi = (data) => Axios.get(sign + '/check/entByName', data);
